import { render } from "./sectionLoader.vue?vue&type=template&id=3b1d8229&scoped=true"
import script from "./sectionLoader.vue?vue&type=script&lang=js"
export * from "./sectionLoader.vue?vue&type=script&lang=js"

import "./sectionLoader.vue?vue&type=style&index=0&id=3b1d8229&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1d8229"]])

export default __exports__